import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateNewExclusionList = document.createElement('template');

templateNewExclusionList.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-title fontweight="500" fontsize="20" style="padding: 20px;"></gz-title>
    <div class="header">
        <gz-exclusion-list-form></gz-exclusion-list-form>
    </div>

    <div class="content">
       <gz-exclusion-item-form></gz-exclusion-item-form>
       <gz-exclusion-item-grid></gz-exclusion-item-grid>
    </div>

    <div class="footer">
        <gz-button class="footer--button" id="btnSave" disabled></gz-button>
        <gz-button class="footer--button" id="btnCancel" type="outline" color="secondary"></gz-button>
    </div>
  </div>
`;
